import React from 'react'
import { Checkbox, Col, ColorPicker, Row, Tooltip, Typography } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import { DatahubLinkMaxInput } from './DatahubLinkMaxInput'
import { CnDatahubCategoryAccess } from './datahub-interfaces'
import { AggregationColor } from 'antd/es/color-picker/color'
import { DatahubColumnsEditorMode } from './DatahubColumnsEditor'

interface DatahubGeneralPanelProps {
  access: CnDatahubCategoryAccess
  categoryNameInput: React.ReactNode
  onChange: (patch: Partial<CnDatahubCategoryAccess>) => void
  mode: DatahubColumnsEditorMode
}

export function DatahubGeneralPanel({ access, categoryNameInput, onChange, mode }: DatahubGeneralPanelProps) {
  return (
    <Row gutter={[12, 8]}>
      <Col xs={24} md={12}>{categoryNameInput}</Col>
      <Col xs={24} md={12}>
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          Couleur
        </Typography.Text>
        <div style={{ marginTop: 2 }}>
          <ColorPicker
            size="small"
            value={access.color}
            disabledAlpha
            onChange={(color: AggregationColor) =>
              onChange({ color: '#' + color.toHex() })
            }
          />
        </div>
      </Col>
      <Col xs={12} sm={6}>
        <DatahubLinkMaxInput
          label="Liens contact max"
          value={access.linkContactMax ?? 0}
          onChange={(value) => onChange({ linkContactMax: value })}
        />
      </Col>
      <Col xs={12} sm={6}>
        <DatahubLinkMaxInput
          label="Liens pièce jointe max"
          value={access.linkAttachmentMax ?? 0}
          onChange={(value) => onChange({ linkAttachmentMax: value })}
        />
      </Col>
      <Col xs={12} sm={6}>
        <DatahubLinkMaxInput
          label="Liens entreprise max"
          value={access.linkEntrepriseMax ?? 0}
          onChange={(value) => onChange({ linkEntrepriseMax: value })}
        />
      </Col>
      <Col xs={12} sm={6}>
        <DatahubLinkMaxInput
          label="Liens RDV max"
          value={access.linkRdvMax ?? 0}
          onChange={(value) => onChange({ linkRdvMax: value })}
        />
      </Col>
      {mode === 'private' && (
        <Col xs={24}>
          <Checkbox
            checked={access.removeManualCreation === true}
            onChange={(e) =>
              onChange({ removeManualCreation: e.target.checked || null })
            }
          >
            Supprimer la création manuelle
            <Tooltip
              title={<div style={{ whiteSpace: 'pre-line' }}>Si activé, les utilisateurs ne pourront pas créer manuellement des éléments de cette catégorie.</div>}
            >
              <InfoCircleOutlined style={{ marginLeft: 6, color: 'rgba(0,0,0,0.45)' }} />
            </Tooltip>
          </Checkbox>
        </Col>
      )}
    </Row>
  )
}
